import * as React from 'react';
import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import styled, { css, withTheme, keyframes } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate, { translate } from './Translate';
import Badge from './Badge';
import Icon from './Icon';
import { computed } from 'mobx';
import { TranslationStore } from '../stores';

const bounce = keyframes`
    from,
    20%,
    53%,
    80%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      transform: translate3d(0, 0, 0);
    }
  
    40%,
    43% {
      animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      transform: translate3d(0, -0.5em, 0);
    }
  
    70% {
      animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      transform: translate3d(0, -0.25em, 0);
    }
  
    90% {
      transform: translate3d(0, -0.05em, 0);
    }
`;

const bounceRule = css`
    ${bounce}
`;

const Wrapper = styled<any, any>('div')`
    ${propStyles};
`;

Wrapper.defaultProps = {
    display: 'flex',
    alignItems: 'center',
};

const DownloadButtonIcon = styled<any, any>(Icon)``;

DownloadButtonIcon.defaultProps = {
    marginX: 'sm',
    height: '1.6em',
    width: '1.6em',
};

const Button = styled<any, any>('button')`
    ${propStyles};
    &:hover {
        ${DownloadButtonIcon} {
            animation-name: ${bounceRule};
            animation-duration: 1s;
            animation-fill-mode: both;
            transform-origin: center bottom;
        }
    }
`;

Button.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    paddingX: '0',
    paddingY: '0',
    fontSize: 'inherit',
    fontFamily: 'body',
    fontWeight: 'regular',
    textAlign: 'left',
    color: 'inherit',
    bgColor: 'transparent',
    borderStyle: 'none',
    cursor: 'pointer',
    outline: 'none',
    hover: {
        color: 'primary',
    },
};

interface DownloadControlsProps {
    theme?: any;
    translationStore?: TranslationStore;
    label?: string;
    showCount?: boolean;
    showDownload?: boolean;
    count?: number;
    onClick?: () => {};
    disabled?: boolean;
    downloadButtonFileName?: string;
    isMobile?: boolean;
    showLabel?: boolean;
}

@inject('translationStore')
@observer
class DownloadControls extends Component<DownloadControlsProps> {
    @computed
    get title() {
        const { label, translationStore } = this.props;
        let text = 'Download';
        if (label) {
            text = `${label} Download`;
        }
        return translate(translationStore, text);
    }

    render() {
        const {
            theme,
            translationStore,
            label,
            showCount = true,
            showDownload = true,
            count = 0,
            onClick,
            disabled,
            downloadButtonFileName = 'DownloadIcon',
            isMobile = false,
            showLabel = true,
            ...props
        } = this.props;
        // Set up the object assign to avoid breaking existing style selectors
        const downloadControlsTheme = isMobile
            ? { ...theme.DownloadControls, ...theme.DownloadControlsMobile }
            : theme.DownloadControls;
        const downloadButtonTheme = isMobile
            ? { ...theme.DownloadButton, ...theme.DownloadButtonMobile }
            : theme.DownloadButton;

        // default icon to center when no label and right for mobile
        let buttonIconTheme = theme.DownloadButtonIcon;
        if (!showLabel) {
            buttonIconTheme = {
                margin: isMobile ? '0 0 0 auto' : '0 auto',
                ...theme.DownloadButtonIcon,
                ...theme.DownloadButtonIconNoLabel,
            };
        }
        const downloadButtonIconTheme = isMobile
            ? {
                  ...buttonIconTheme,
                  ...theme.DownloadButtonIconMobile,
              }
            : buttonIconTheme;
        const downloadCountTheme = isMobile
            ? { ...theme.DownloadCount, ...theme.DownloadCountMobile }
            : theme.DownloadCount;
        return (
            <Wrapper {...props} {...downloadControlsTheme}>
                {showDownload && (
                    <Button
                        title={translate(translationStore, 'Download')}
                        onClick={onClick}
                        disabled={disabled}
                        {...downloadButtonTheme}
                    >
                        {label && showLabel && <Translate>{label}</Translate>}
                        <DownloadButtonIcon
                            fileName={downloadButtonFileName}
                            {...downloadButtonIconTheme}
                        />
                    </Button>
                )}
                {showCount && (
                    <Badge bgColor="primary" {...downloadCountTheme}>
                        {count}
                    </Badge>
                )}
            </Wrapper>
        );
    }
}

export default withTheme(DownloadControls) as any;



// WEBPACK FOOTER //
// ./src/Components/DownloadControls.tsx